import Bowser from 'bowser';
import { useMediaQuery } from 'usehooks-ts';

const { browser, os, platform, engine }: Bowser.Parser.ParsedResult = Bowser.parse(window.navigator.userAgent);

const isNotValidIE =
  (browser.name === 'Internet Explorer' && Number(browser.version) < 11.0) ||
  (browser.name === 'Chrome' && Number(browser.version) < 23.0) ||
  (browser.name === 'Firefox' && Number(browser.version) < 21.0) ||
  (browser.name === 'Safari' && Number(browser.version) < 6.0) ||
  (browser.name === 'Opera' && Number(browser.version) < 15.0) ||
  (browser.name === 'Android Browser' && Number(browser.version) < 4.4);

const isMobile = !!(platform.type === 'mobile');
const isTablet = !!(platform.type === 'tablet');
const isDesktop = !!(platform.type === 'desktop');

const isIOS = !!(os.name === 'iOS');
const isAndroid = !!(os.name === 'Android');

export const useBowser = () => {
  const mobileQuery = useMediaQuery('(max-width: 991px)');
  const desktopQuery = useMediaQuery('(min-width: 991px)');

  return {
    browser,
    engine,
    isNotValidIE,
    os,
    platform,
    isMobile: isMobile || mobileQuery,
    isTablet,
    isDesktop: isDesktop && desktopQuery,
    isIOS,
    isAndroid,
  };
};
